  document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll("section, header");
    const navLinks = document.querySelectorAll("nav a");

    const observerOptions = {
      root: null, // viewport
      rootMargin: "-30% 0px -65% 0px", // triggers when the section is in the middle
      threshold: 0 // triggers when it enters viewport
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          navLinks.forEach(link => link.classList.remove("active"));
          const activeLink = document.querySelector(`nav a[href="#${entry.target.id}"]`);
          if (activeLink) activeLink.classList.add("active");
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    sections.forEach(section => observer.observe(section));

    const checkInitialSection = () => {
    const firstVisibleSection = Array.from(sections).find(section => {
        const rect = section.getBoundingClientRect();
        return rect.top >= 0 && rect.bottom > 0;
    });

    if (firstVisibleSection) {
        navLinks.forEach(link => link.classList.remove("active"));
        const activeLink = document.querySelector(`nav a[href="#${firstVisibleSection.id}"]`);
        if (activeLink) activeLink.classList.add("active");
    }
    };

    // Call it on load
    checkInitialSection();
  });